// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Utils$Coronate from "../Utils.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PageRound$Coronate from "./PageRound.res.js";
import * as Data_Rounds$Coronate from "../Data/Data_Rounds.res.js";
import * as PageTourneyScores$Coronate from "./PageTourneyScores.res.js";

function PageTournamentStatus(props) {
  var tournament = props.tournament;
  var tourney = tournament.tourney;
  var lastRoundId = Data_Rounds$Coronate.getLastKey(tourney.roundList);
  var lastRound = Data_Rounds$Coronate.get(tourney.roundList, lastRoundId);
  var tmp;
  if (lastRound !== undefined) {
    var matches = Caml_option.valFromOption(lastRound);
    tmp = Data_Rounds$Coronate.Round.size(matches) === 0 ? JsxRuntime.jsx("p", {
            children: "Matched players in the current round will be shown here."
          }) : JsxRuntime.jsx(PageRound$Coronate.RoundTable.make, {
            isCompact: true,
            roundId: lastRoundId,
            matches: Data_Rounds$Coronate.Round.toArray(matches),
            tournament: tournament
          });
  } else {
    tmp = JsxRuntime.jsx("p", {
          children: "No rounds played yet."
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("h2", {
                      children: "Tournament status",
                      style: {
                        textAlign: "center"
                      }
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs(Utils$Coronate.PanelContainer.make, {
                            children: [
                              JsxRuntime.jsx(Utils$Coronate.Panel.make, {
                                    children: tmp
                                  }),
                              JsxRuntime.jsx(Utils$Coronate.Panel.make, {
                                    children: JsxRuntime.jsx(PageTourneyScores$Coronate.ScoreTable.make, {
                                          size: "Compact",
                                          tourney: tourney,
                                          getPlayer: tournament.getPlayer,
                                          title: "Rankings"
                                        })
                                  })
                            ],
                            style: {
                              justifyContent: "center"
                            }
                          }),
                      className: "content-area"
                    })
              ]
            });
}

var make = PageTournamentStatus;

export {
  make ,
}
/* Utils-Coronate Not a pure module */
